import xpSolvService from "../axios/axios";
// eslint-disable-next-line import/order, import/no-unresolved
import Utility from "src/utils/Utility";

class HistoryTestService {

    historyTest(data) {
        data =  Utility.addRoleInBody(data);
        return Promise.resolve(xpSolvService.post('testhistown', data));
    }
    
    testReceived(data) {
        return Promise.resolve(xpSolvService.post('testreceived', data));
    }

    genhtml(data) {
        return Promise.resolve(xpSolvService.post('genhtml', data));
    }

    getStudentSubject(data) {
        data =  Utility.addRoleInBody(data);
        return Promise.resolve(xpSolvService.post(`getsubject`,data));
    }

    generateReport(data) {
        return Promise.resolve(xpSolvService.post('perfreport', data));
    }  
}

export default HistoryTestService;